import { render, staticRenderFns } from "./outlook-read-email.vue?vue&type=template&id=58809b75&scoped=true"
import script from "./outlook-read-email.vue?vue&type=script&lang=js"
export * from "./outlook-read-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58809b75",
  null
  
)

export default component.exports